import Building from '@models/building/Building'
import Unitairvolume from '@models/airvolumes/Unitairvolume'
import Roomairvolume from '@models/airvolumes/Roomairvolume'
import store from '@store'
import Unit from '../../models/building/Unit'
import Systemselection from '@models/airvolumes/Systemselection'
import Installation from '@models/airvolumes/Installation'
import Valve from '@models/airvolumes/Valve'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'
import RoomltmsHasOperationmode from '@models/helpers/RoomltmsHasOperationmode'

export default {
  calculate(unitId = null) {
    this.building = Building.query().first()
    this.unit = Unit.query().where('id', unitId).with(['airvolume', 'installation', 'systemselection', 'rooms.airvolume', 'rooms.valve']).first()

    if (this.unit.rooms.length <= 0) return

    if (this.unit.airvolume == null) {
      this.unit.airvolume = new Unitairvolume({unitId: this.unit.id})
    }
    if (this.unit.systemselection == null) {
      this.unit.systemselection = new Systemselection({
        unitId: this.unit.id,
        deviceLevel: this.unit.level,
      })
    }
    if (this.unit.installation == null) {
      this.unit.installation = new Installation({
        unitId: this.unit.id,
        storey: this.unit.storey,
      })
    }
    this.unit.rooms.forEach((room) => {
      if (room.airvolume == null) {
        room.airvolume = new Roomairvolume({roomId: room.id, doorLeaf: room.getRoomtypeDoorLeaf()})
      }
      if (room.airvolume.doorLeaf == 0 || room.airvolume.doorLeaf == null) {
        room.airvolume.doorLeaf = room.getRoomtypeDoorLeaf()
      }
      if (room.valve == null) {
        room.valve = new Valve({roomId: room.id})
      }
      if (room.airType == 3) room.airvolume.resetOverflowRoom()
    })

    this.getConstants()
    this.basicCalculations()
    this.fZuCalculation()

    // DIN 18017 = ltm 1, 7 | DIN 1946 = ltm 2 | WRG = ltm 3, 4 | Kombi = ltm 5,6

    this.setDefaultOperationmode()
    this.calculateTotalOperationmodeAir()
    this.totalExhaustAirCalculation()
    this.calculateEquation8()
    this.calculateEquation28()
    this.calculateEquation9()
    this.calculateExhaustAir()
    this.calculateEquation30()
    this.calculate1946SupplyAir()

    this.calculateTotalAirvolumes()
    this.calculateAirvolumeVariations()

    this.calculateUld()
    this.calculateValves()

    Unit.insertOrUpdate({data: [this.unit]})
    return
  },

  getConstants() {
    this.fLstnl = store.getters['constants/getFlstnl']
    this.fLstil = store.getters['constants/getFlstil']
    this.fLstrl = store.getters['constants/getFlstrl']
    this.fLstfl = store.getters['constants/getTable6Constant']({
      buildingHeatProtection: this.building.heatProtection,
      unitOccupancy: this.unit.occupancy
    })
    this.eZ = store.getters['constants/getTable9Constant']({
      unitLtm: this.unit.ventilationMeasure,
      unitFireplace: this.unit.fireplace
    })
    this.n50 = store.getters['constants/getTable10Constant']({
      buildingAirtightness: this.building.airtightness,
      buildingAirExchange: this.building.airExchange
    })
  },

  basicCalculations() {
    this.unit.airvolume.space = 0
    this.unit.airvolume.height = 0
    this.unit.airvolume.volume = 0

    this.unit.airvolume.aldSpace = 0
    this.unit.airvolume.aldVolume = 0

    this.unit.rooms.forEach(
      function (room) {
        if (room.ventilationMeasure != 6) this.unit.airvolume.space += room.space
        if (room.ventilationMeasure != 1) this.unit.airvolume.aldSpace += room.space
        this.unit.airvolume.height += room.height
      }.bind(this)
    )

    this.unit.airvolume.height = this.unit.airvolume.height / this.unit.rooms.length
    this.unit.airvolume.volume = +parseFloat((this.unit.airvolume.space * this.unit.airvolume.height).toFixed(2))
    this.unit.airvolume.aldVolume = +parseFloat((this.unit.airvolume.aldSpace * this.unit.airvolume.height).toFixed(2))
  },

  fZuCalculation() {
    this.unit.airvolume.totalFrZu = 0
    this.unit.airvolume.totalFrZuKorr = 0
    this.unit.rooms.forEach((room) => {
      room.airvolume.resetFZu = true
      room.airvolume.setFZu()
      this.unit.airvolume.totalFrZu += room.airvolume.fZu
      this.unit.airvolume.totalFrZuKorr += room.airvolume.fZuKorr
    })
  },

  totalExhaustAirCalculation() {
    this.unit.airvolume.exhaustAir = 0
    this.unit.rooms.forEach((room) => {
      if (room.airType != 1 || room.ventilationMeasure == 7) return
      this.unit.airvolume.exhaustAir += room.getRoomtypeAirvolume()
    })
  },

  calculateEquation8() {
    if (this.unit.airvolume.space < 210) {
      this.unit.airvolume.nl = this.fLstnl * (-0.002 * Math.pow(this.unit.airvolume.space, 2) + 1.15 * this.unit.airvolume.space + 11)
    } else {
      this.unit.airvolume.nl = ((this.unit.airvolume.space - 210) / 10) * 4 + this.fLstnl * (-0.002 * Math.pow(210, 2) + 1.15 * 210 + 11)
    }
  },

  calculateEquation28() {
    this.unit.airvolume.nl = Math.max(this.unit.airvolume.nl, Math.min(this.unit.airvolume.exhaustAir, 1.2 * this.unit.airvolume.nl))
  },

  calculateExhaustAir() {
    let exhaustAir = 0
    this.unit.rooms.forEach(
      function (room) {
        if (room.airType != 1) return
        if (room.ventilationMeasure == 7) {
          room.airvolume.airvolume = 0
          return
        }
        room.airvolume.airvolume = this.nfcRounding(room.getRoomtypeAirvolume() * this.unit.airvolume.nl / this.unit.airvolume.exhaustAir);
        exhaustAir += room.airvolume.airvolume
      }.bind(this)
    )
    this.unit.airvolume.totalExhaustAir = exhaustAir
  },

  calculateEquation9() {
    this.unit.airvolume.infiltrationAir = this.eZ * this.unit.airvolume.volume * this.n50
  },

  calculateEquation30() {
    //this.unit.airvolume.nl = this.unit.airvolume.nl - this.unit.airvolume.infiltrationAir
  },

  calculate1946SupplyAir() {
    var changes = 0
    var ald = 0
    var inf = 0
    var nl = 0

    // get min airvolume
    let minAirvolume = 0
    this.unit.rooms.forEach(room => {
      if (room.airType != 2) return
      minAirvolume += room.getRoomtypeAirvolume()
    })

    this.unit.rooms.forEach(
      function (room, index) {
        if (room.airType != 2) return
        let roomMinAirvolume = room.getRoomtypeAirvolume()
        room.airvolume.ald = Math.round(((this.unit.airvolume.totalExhaustAir - this.unit.airvolume.infiltrationAir) / minAirvolume) * roomMinAirvolume)
        room.airvolume.infiltrationAir = Math.round((this.unit.airvolume.infiltrationAir / minAirvolume) * roomMinAirvolume)
        room.airvolume.airvolume = room.airvolume.ald + room.airvolume.infiltrationAir

        if (room.airvolume.airvolume < roomMinAirvolume) {
          room.airvolume.airvolume = roomMinAirvolume
          room.airvolume.ald = roomMinAirvolume - room.airvolume.infiltrationAir
        }
        ald += room.airvolume.ald
        inf += room.airvolume.infiltrationAir
        nl += room.airvolume.airvolume
      }.bind(this)
    )
    this.unit.airvolume.ald = ald
    this.unit.airvolume.infiltrationAir = inf
    //this.unit.airvolume.nl = nl
    this.unit.airvolume.totalSupplyAir = nl
  },

  setDefaultOperationmode() {
    this.unit.rooms.forEach((room) => {
      if (room.airvolume.operationmode == null || room.airvolume.operationmode <= 0 || !RoomltmsHasOperationmode.query().where('roomltms_id', room.ventilationMeasure).where('operationmodes_id', room.airvolume.operationmode).exists()) {
        var operationmode = RoomltmsHasOperationmode.query().where('roomltms_id', room.ventilationMeasure).where('default', 1).first()
        room.airvolume.operationmode = operationmode.operationmodes_id
      }
      if (room.airvolume.operationmodeAirvolume == null || room.airvolume.operationmodeAirvolume <= 0 || !RoomtypesHasOperationmodesHasAirvolume.query().where('id', room.airvolume.operationmodeAirvolume).where('operationmodes_id', room.airvolume.operationmode).exists()) {
        var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolume.query().where('operationmodes_id', room.airvolume.operationmode).where('roomtypes_id', room.type).where('window', +room.window).where('default', true).first()
        if (operationmodeAirvolume != undefined || operationmodeAirvolume != null) {
          room.airvolume.operationmodeAirvolume = operationmodeAirvolume.id
        }
      }
    })
  },

  calculateTotalOperationmodeAir() {
    this.unit.airvolume.totalNeedAir = 0
    this.unit.airvolume.totalDurationAir = 0
    this.unit.rooms.forEach(
      function (room, index) {
        if (room.airvolume.operationmodeAirvolume == null || room.airvolume.operationmodeAirvolume <= 0 || !(room.ventilationMeasure == 1 || room.ventilationMeasure == 6)) return
        var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolume.find(room.airvolume.operationmodeAirvolume)
        this.unit.airvolume.totalNeedAir += operationmodeAirvolume.need_airvolume
        this.unit.airvolume.totalDurationAir += operationmodeAirvolume.duration_airvolume
      }.bind(this)
    )
  },

  calculateAirvolumeVariations() {
    this.unit.airvolume.nl = Math.round(this.unit.airvolume.nl)
    this.unit.airvolume.rl = Math.round(this.unit.airvolume.nl * this.fLstrl)
    this.unit.airvolume.il = Math.round(this.unit.airvolume.nl * this.fLstil)
    this.unit.airvolume.fl = Math.round(this.unit.airvolume.nl * this.fLstfl)

    this.unit.airvolume.nlExchange = +parseFloat(this.unit.airvolume.nl / this.unit.airvolume.volume).toFixed(2)
    this.unit.airvolume.rlExchange = +parseFloat(this.unit.airvolume.rl / this.unit.airvolume.volume).toFixed(2)
    this.unit.airvolume.ilExchange = +parseFloat(this.unit.airvolume.il / this.unit.airvolume.volume).toFixed(2)
    this.unit.airvolume.flExchange = +parseFloat(this.unit.airvolume.fl / this.unit.airvolume.volume).toFixed(2)
  },

  calculateUld() {
    var f_uld = 3.1
    var p_uld = 1.5
    if (this.unit.overflowSeal == 1) var k_dichtung = 25
    if (this.unit.overflowSeal == 0) var k_dichtung = 0

    this.unit.rooms.forEach((room) => {
      var airvolume = 0
      if (room.airvolume.operationmodeAirvolume > 0) airvolume = RoomtypesHasOperationmodesHasAirvolume.find(room.airvolume.operationmodeAirvolume).duration_airvolume
      if (airvolume <= 0 || airvolume == null) airvolume = room.airvolume.airvolume
      if (airvolume <= 0 || airvolume == null) {
        room.airvolume.uld = 0
        return
      }
      room.airvolume.uld = +parseFloat((f_uld * airvolume) / Math.pow(p_uld, 0.5) - k_dichtung).toFixed(1)
    })
  },

  calculateValves() {
    this.unit.rooms.some(
      function (room) {
        if (room.valve.valvesAmmount == null || room.valve.valvesAmmount <= 0) {
          room.valve.valvesAmmount = Math.ceil(room.airvolume.airvolume / 60)
          if (this.unit.systemselection.pipeProfile == 2) {
            room.valve.pipesAmmount = Math.ceil(room.airvolume.airvolume / 20)
          } else {
            room.valve.pipesAmmount = Math.ceil(room.airvolume.airvolume / 30)
          }
          if (room.valve.pipesAmmount < room.valve.valvesAmmount) {
            room.valve.pipesAmmount = room.valve.valvesAmmount
          }
        }
      }.bind(this)
    )
  },

  calculateTotalAirvolumes() {
    this.unit.airvolume.totalSupplyAir = 0
    this.unit.airvolume.totalExhaustAir = 0

    this.unit.rooms.forEach(
      function (room) {
        if (room.ventilationMeasure == 7) {
          room.airvolume.airvolume = 0
          return
        }
        if (room.airType == 2) {
          this.unit.airvolume.totalSupplyAir += parseFloat(room.airvolume.airvolume)
          room.airvolume.nlZu = +parseFloat(room.airvolume.airvolume).toFixed(0)
          room.airvolume.nlAb = '-'
        } else if (room.airType == 1) {
          this.unit.airvolume.totalExhaustAir += parseFloat(room.airvolume.airvolume)
          room.airvolume.nlAb = +parseFloat(room.airvolume.airvolume).toFixed(0)
          room.airvolume.nlZu = '-'
        }
        room.airvolume.rl = room.airvolume.airvolume * this.fLstrl
        room.airvolume.il = room.airvolume.airvolume * this.fLstil
        room.airvolume.fl = room.airvolume.airvolume * this.fLstfl
      }.bind(this)
    )
    this.unit.airvolume.totalSupplyAir = Math.round(this.unit.airvolume.totalSupplyAir)
    this.unit.airvolume.totalExhaustAir = Math.round(this.unit.airvolume.totalExhaustAir)
  },

  nfcRounding(value) {
    let quotient = 5
    if (value > 50) {
      quotient = 10
    }
    return Math.ceil(value / quotient) * quotient;
  }
}
